export const IconFieldTailwindThemes = {
  iconfield: {
    root: {
      className: 'inline-block relative'
    }
  }
};
